/**
 * Smooth ~1s scroll for header "Software nav link" blocks (Map Expand /
 * Infinite Asset Customizer), so clicking them eases into the target
 * section instead of jumping instantly, landing slightly above the anchor
 * rather than flush against it. Native `scroll-behavior: smooth` isn't
 * used because its duration/easing isn't controllable or consistent
 * across browsers.
 */
(function () {
  var SCROLL_DURATION_MS = 1000;
  var LANDING_GAP_PX = 24;

  function easeInOutCubic(t) {
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
  }

  function getHeaderOffset() {
    var header = document.querySelector('.section-header');
    return header ? header.offsetHeight : 0;
  }

  function smoothScrollTo(targetY, onDone) {
    var startY = window.pageYOffset;
    var distance = targetY - startY;
    var startTime = null;

    function step(timestamp) {
      if (startTime === null) startTime = timestamp;
      var elapsed = timestamp - startTime;
      var progress = Math.min(elapsed / SCROLL_DURATION_MS, 1);
      window.scrollTo(0, startY + distance * easeInOutCubic(progress));

      if (progress < 1) {
        requestAnimationFrame(step);
      } else if (typeof onDone === 'function') {
        onDone();
      }
    }

    requestAnimationFrame(step);
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('a.wrpg-software-nav-link[href*="#"]');
    if (!link) return;

    var url;
    try {
      url = new URL(link.href, window.location.href);
    } catch (error) {
      return;
    }

    var isSamePage = url.pathname === window.location.pathname && url.search === window.location.search;
    var hash = url.hash.replace('#', '');
    if (!isSamePage || !hash) return;

    var target = document.getElementById(hash);
    if (!target) return;

    event.preventDefault();

    var targetY = target.getBoundingClientRect().top + window.pageYOffset - getHeaderOffset() - LANDING_GAP_PX;
    targetY = Math.max(targetY, 0);

    smoothScrollTo(targetY, function () {
      history.replaceState(null, '', '#' + hash);
    });
  });
})();
